import React from 'react';

interface CloseBtnProps {
    onClick: () => void
}

const CloseBtn: React.FC<CloseBtnProps> = ({ onClick }) => {
    return (
        <svg  onClick={onClick} focusable="false" width="24" height="24" viewBox="0 0 24 24" className='cursor-pointer' >
            <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z"></path>
        </svg>
    )
}

export default CloseBtn